<template>
  <div class="row">
    <div class="col-xs-8 el-col-offset-4" style="border-bottom: 2px solid #000; margin-bottom: 1em; margin-top: 2.2em;"></div>
    <div class="col-xs-12">
      <p style="text-align: center;">
        <span class="uppercase">NOME: <strong>{{ customer.holder }}</strong> </span>
        <span v-if="customer.cpf"> CPF: <strong>{{ customer.cpf }}</strong> </span>
        <span v-if="customer.nationalId"> RG: <strong>{{ customer.nationalId }}</strong> </span>
        <span v-if="customer.nis"> NIS: <strong>{{ customer.nis }}</strong> </span>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'signature-customer-ticket',
  props: {
    customer: {}
  }
}
</script>
<style scoped>
  span {
    margin-left: 5px;
    margin-right: 5px;
  }
  .uppercase {
    text-transform: uppercase;
  }

  p, li {
    font-size: 7pt;
    text-align: justify;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/SignatureCustomerTicket.vue